import React from 'react'

function Thinking() {
    return (
        <div>Thinking</div>
    )
}

export default Thinking